module.exports = __webpack_public_path__ + "img/seedling-solid.7b04191b.svg";